import { Modal } from 'bootstrap';

export const initPopupBanners = () => {
  document.querySelectorAll('[data-js-popup-banner]').forEach((element) => {
    Modal.getOrCreateInstance(element).show();
  });
};
